import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { SetService, HttpService, JwtService, PageService } from 'ngx-block-core';
import { ActivatedRoute } from '@angular/router';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-table-form-input',
  templateUrl: './table-form-input.component.html',
  styleUrls: ['./table-form-input.component.less']
})
export class TableFormInputComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() ColumnData;
  @Input() data;
  sets;
  nzFormGroupData;
  @Input() blockid = "";
  @Input() formId = "";
  @Input() columnName = "";
  @Input() index = 0;

  @ViewChild('input') input: ElementRef;

  constructor(private setService: SetService,
    private activatedRoute: ActivatedRoute,
    private jwtService: JwtService,
    private pageService: PageService,
    private http: HttpService) { }

  ngOnInit() {
    this.sets = this.ColumnData['nzBlockSets'];
    this.nzFormGroupData = this.ColumnData['nzFormGroupData'];
    this.nzFormGroupData.sets['childFormId'] = this.formId;
    // this.setService.pageDatas['form_' + this.blockid + this.formId] = this.form;
    // console.log("form", this.form)
    // console.log("form2", this.form.get(this.nzFormGroupData.nzKey).value)
    this.form.get(this.nzFormGroupData.nzKey).valueChanges.pipe(
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(400),
    ).subscribe((val) => {
      console.log("form-inputmchange", this.columnName, val, this.blockid)
      this.setService.events[this.blockid].emit({
        type: "childChange",
        datas: { index: this.index, columnName: this.columnName, formId: this.formId, value: val }
      });
      this.hiddendatas_main('change');
      const nzFocusField = this.sets['styles']['nzFocusField']
      const next = this.nzFormGroupData['nzValue']['nzValueFormat'] == 'focus';
      if (next || nzFocusField) {

        console.log('nzFocusField', this.sets['styles']['nzFocusField'])
        console.log("form-focus")
        this.setService.events[this.blockid].emit({
          type: "focus",
          datas: { index: this.index + (next ? 0 : -1), columnName: nzFocusField ? nzFocusField : this.columnName }
        });
      }
      //校验
      // if (this.ColumnData['onlyValue']) {
      //   console.log("onlyValue",)
      //   this.setService.events[this.blockid].emit({
      //     type: "check_childTableOne",
      //     datas: {}
      //   });

      // }

      for (const key in this.needCalculate) {
        const element = this.needCalculate[key];
        if (element.used) {
          this.setService.events[this.blockid + this.formId + element.id].emit({
            type: 'changeCalculateValue',
          });
        }
      }

      //联动
      if (this.sets.datas.nzLinkage.nzUsed) {
        if (val) {
          this.sets.datas.nzLinkage.nzEvents.forEach(element => {
            this.setService.events[this.blockid + this.formId + element.blockid].emit({
              type: "linkage" + element.type,
              datas: { value: val }
            });
          });
        } else {
          this.sets.datas.nzLinkage.nzEvents.forEach(element => {
            this.setService.events[this.blockid + this.formId + element.blockid].emit({
              type: "linkageOld",
              datas: { value: val }
            });
          });
        }

      }
    });



    this.Listening();
    this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName] = {
      nzHiddendatas: {
      }
    }
  }
  needCalculate = {};
  /**
 * 计算功能初始化
 */
  initCalculate(open = true) {
    if (this.sets.datas.nzSameTableCalculate.nzUsed || open == false) {
      this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
        // element.field 字段名
        // element.name @v1这种
        this.calculate_name_key[element.name] = element.field;
        this.setService.events[this.blockid + this.formId + element.field].emit({
          type: 'needCalculate',
          datas: {
            used: open,
            id: this.columnName,
            name: element.name
          }
        });
      });
      if (open)
        this.calculateValue()
    }
  }
  calculate_name_key = {}
  ngOnDestroy() {
    this.setService.deleteEvent(this.blockid + this.formId + this.columnName)
  }
  Listening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid + this.formId + this.columnName);
      this.setService.events[this.blockid + this.formId + this.columnName].subscribe(
        data => {
          switch (data['type']) {
            case 'needCalculate':
              //变更值后通知目标积木
              this.needCalculate[data.datas.id] = data.datas;
              break;
            case 'changeCalculateValue':
              this.calculateValue()
              break;
            case 'linkagevalue':
              this.linkageValue(data.datas.value, '')
              break;
            case 'linkagevalue2':
              this.linkageValue(data.datas.value, '2')
              break;
            case 'linkagevalue3':
              this.linkageValue(data.datas.value, '3')
              break;
            case 'linkagevaluek1':
              this.linkageValue(data.datas.value, 'k1')
              break;
            case 'linkageOld':
              try {
                if (this.sets.datas.nzLinkageData.nullOld) {
                  // this.form.get(this.nzFormGroupData.nzKey).patchValue(this.data[this.columnName])
                }
              } catch (error) {

              }
              break;

            case 'focus':

              console.log('ViewChild获取匹配的元素2:', this.input.nativeElement);
              this.input.nativeElement.focus();
              break;

            default:
              break;
          }

        }
      )
      setTimeout(() => {
        this.initCalculate()
      }, 100);
    }, 100);

  }

  hiddendatas_main(time) {
    console.log("this.sets", this.sets, JSON.stringify(this.sets))
    this.sets.datas.nzHiddendatas.nzNames.forEach(paramName => {
      const data = this.sets.datas.nzHiddendatas.nzSets[paramName];
      if (data['getTime'].indexOf(time) >= 0) {
        //先清除数据
        if (this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName] !== undefined) {
          delete this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName]
        }
        //获取数据
        this.hiddendatas_get(paramName, data)
      }
    });
  }
  hiddendatas_get(paramName, data) {
    console.log('hiddendatas_get...', paramName, data);
    // {name: "param1", column: Array(0), type: "column", getTime: Array(1), sql: "", …}
    // column: []
    // errorMsg: ""
    // getTime: ["change"]
    // name: "param1"
    // sql: ""
    // type: "column"
    switch (data.type) {
      case 'sql':
        this.hiddendatas_sql(paramName, data);
        console.log('hiddendatas_sqldoing...');

        break;
      case 'column':
        this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName] = {
          name: data.name,
          value: this.form.get(this.columnName).value,
          state: 'success',
          msg: ""
        }
        break;

      default:
        break;
    }
  }




  hiddendatas_sql(paramName, set) {
    let sql = set.sql;
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    if (typeof this.linkValue.linkagek1 != "undefined") sql = sql.replace(new RegExp("@linkagek1", "gm"), this.linkValue.linkagek1);
    if (typeof this.form.get(this.nzFormGroupData.nzKey).value != "undefined") sql = sql.replace(new RegExp("@currentValue@", "gm"), this.form.get(this.nzFormGroupData.nzKey).value);

    let body = {
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.blockid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("hiddendatas_sql_body:" + JSON.stringify(body));

    console.log("hiddendatas_sql_body2:" + JSON.stringify(body));

    if (sql.indexOf("@linkage") == -1 && sql.indexOf("@currentValue@") == -1 && body.dynamicSql != "") {
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("hiddendatas_sql_data", data)
          if (data.data.list.length > 0) {
            this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName] = {
              name: set.name,
              value: data.data.list[0]['VALUE'],
              state: 'success',
              msg: ""
            }
          }
          else {
            this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName] = {
              name: set.name,
              value: "",
              state: 'error',
              msg: set.errorMsg
            }
          }
          console.log("hiddendatas_sql_end", this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'])
        },
        (error: any) => {
          this.pageService.pageBlockDatas[this.blockid + this.formId + this.columnName]['nzHiddendatas'][paramName] = {
            name: set.name,
            value: "",
            state: 'error',
            msg: set.errorMsg
          }
        })
    }

  }

  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: "",
    linkagek1: ""
  }
  linkageValue(value, type) {
    this.form.get(this.nzFormGroupData.nzKey).patchValue('')
    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
    this.linkValue['linkage' + type] = value;
    this.hiddendatas_main('linkage')
    let sql = this.sets.datas.nzLinkageData.nzDynamicSql;
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    if (typeof this.linkValue.linkagek1 != "undefined") sql = sql.replace(new RegExp("@linkagek1", "gm"), this.linkValue.linkagek1);

    let body = {
      // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.blockid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("body:" + JSON.stringify(body));
    if (sql.indexOf("@linkage") == -1) {
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:", this.columnName, body, data,);
          if (data.data.list.length > 0) {
            console.log("dynamicSql:", this.columnName, data.data.list[0]['VALUE'], this.blockid);
            this.form.get(this.nzFormGroupData.nzKey).patchValue(data.data.list[0]['VALUE'])
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
          } else {

          }
        })
    }

  }
  /**
   * 计算数值
   */
  calculateValue() {
    let nzFormula = this.sets.datas.nzSameTableCalculate.nzFormula;
    //取值,替换值
    this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
      console.log("calculate_name_key:" + element.name, JSON.stringify(this.calculate_name_key));
      const value = this.form.get(this.calculate_name_key[element.name]).value;
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);
    });
    //chang
    this.sets.datas.nzSameTableCalculate.nzReplaceValueTwo.forEach(element => {
      console.log("calculate_name_keyTwo:" + JSON.stringify(element));

      let value = this.pageService.getRouteParams(this.activatedRoute, element.field)
      if (value == '') value = element.value
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);


    });

    try {
      console.log("nzFormula:" + nzFormula);
      this.form.get(this.nzFormGroupData.nzKey).patchValue(eval(nzFormula));
      console.log("nzFormulare:" + this.form.get(this.nzFormGroupData.nzKey).value);
    } catch (error) {

    }


  }
  ngModelChange(event) {


  }

}
